/* =====================================================================
   Douce Nuit — panier en tiroir (drawer)
   Ouvre au clic sur l'icône panier, lit/modifie le vrai panier Shopify
   via /cart.js et /cart/change.js. Bouton "Vérifier" -> /checkout.
   ===================================================================== */
(function () {
  "use strict";

  var euro = function (cents) {
    return (cents / 100).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
  };

  var drawer, overlay, body, footer, subtotalEl, countEl, badgeEl;
  var isOpen = false;

  function buildDrawer() {
    overlay = document.createElement("div");
    overlay.className = "cart-drawer__overlay";
    overlay.id = "cartDrawerOverlay";
    overlay.hidden = true;

    drawer = document.createElement("aside");
    drawer.className = "cart-drawer";
    drawer.id = "cartDrawer";
    drawer.hidden = true;
    drawer.setAttribute("role", "dialog");
    drawer.setAttribute("aria-label", "Panier");
    drawer.innerHTML =
      '<div class="cart-drawer__head">' +
        '<h2>Panier <span class="cart-drawer__count" id="cartDrawerCount"></span></h2>' +
        '<button type="button" class="cart-drawer__close" aria-label="Fermer le panier">' +
          '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        "</button>" +
      "</div>" +
      '<div class="cart-drawer__body" id="cartDrawerBody"></div>' +
      '<div class="cart-drawer__footer" id="cartDrawerFooter">' +
        '<div class="cart-drawer__subtotal">' +
          "<span>Sous-total</span>" +
          '<span id="cartDrawerSubtotal">0,00 €</span>' +
        "</div>" +
        '<button type="button" class="btn btn--primary cart-drawer__checkout" id="cartDrawerCheckout">Vérifier</button>' +
      "</div>";

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    body = drawer.querySelector("#cartDrawerBody");
    footer = drawer.querySelector("#cartDrawerFooter");
    subtotalEl = drawer.querySelector("#cartDrawerSubtotal");
    countEl = drawer.querySelector("#cartDrawerCount");

    overlay.addEventListener("click", closeDrawer);
    drawer.querySelector(".cart-drawer__close").addEventListener("click", closeDrawer);
    drawer.querySelector("#cartDrawerCheckout").addEventListener("click", function () {
      window.location.href = "/checkout";
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && isOpen) closeDrawer();
    });
  }

  function renderItems(cart) {
    if (!cart.items.length) {
      body.innerHTML = '<p class="cart-drawer__empty">Votre panier est vide.</p>';
      footer.hidden = true;
      return;
    }
    footer.hidden = false;
    body.innerHTML = cart.items.map(function (item) {
      var img = item.image ? item.image.replace(/(\.[a-zA-Z]+)(\?|$)/, "_200x$1$2") : "";
      var variant = item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";
      return (
        '<div class="cart-drawer__item" data-key="' + item.key + '">' +
          '<div class="cart-drawer__item-media"><img src="' + img + '" alt="" loading="lazy" /></div>' +
          '<div class="cart-drawer__item-info">' +
            '<p class="cart-drawer__item-title">' + item.product_title + "</p>" +
            (variant ? '<p class="cart-drawer__item-variant">' + variant + "</p>" : "") +
            '<div class="cart-drawer__item-row">' +
              '<div class="cart-drawer__qty">' +
                '<button type="button" class="cart-drawer__qty-btn" data-action="decrease" aria-label="Diminuer la quantité">−</button>' +
                '<span>' + item.quantity + "</span>" +
                '<button type="button" class="cart-drawer__qty-btn" data-action="increase" aria-label="Augmenter la quantité">+</button>' +
              "</div>" +
              '<span class="cart-drawer__item-price">' + euro(item.final_line_price) + "</span>" +
            "</div>" +
          "</div>" +
          '<button type="button" class="cart-drawer__remove" data-action="remove" aria-label="Retirer l\'article">' +
            '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 7h16M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2m2 0-1 13a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 7"/></svg>' +
          "</button>" +
        "</div>"
      );
    }).join("");

    [].slice.call(body.querySelectorAll(".cart-drawer__item")).forEach(function (row) {
      var key = row.dataset.key;
      var qtyEl = row.querySelector(".cart-drawer__qty span");
      row.querySelector('[data-action="increase"]').addEventListener("click", function () {
        changeQuantity(key, parseInt(qtyEl.textContent, 10) + 1);
      });
      row.querySelector('[data-action="decrease"]').addEventListener("click", function () {
        changeQuantity(key, parseInt(qtyEl.textContent, 10) - 1);
      });
      row.querySelector('[data-action="remove"]').addEventListener("click", function () {
        changeQuantity(key, 0);
      });
    });
  }

  function updateBadges(count) {
    [].slice.call(document.querySelectorAll(".cart-badge")).forEach(function (el) {
      el.textContent = String(count);
      el.hidden = count === 0;
    });
  }

  function render(cart) {
    countEl.textContent = cart.item_count ? "(" + cart.item_count + ")" : "";
    subtotalEl.textContent = euro(cart.total_price);
    renderItems(cart);
    updateBadges(cart.item_count);
  }

  function fetchCart() {
    return fetch("/cart.js").then(function (r) { return r.json(); });
  }

  function changeQuantity(key, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
    })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  function openDrawer() {
    if (!drawer) buildDrawer();
    isOpen = true;
    overlay.hidden = false;
    drawer.hidden = false;
    document.documentElement.classList.add("cart-drawer-locked");
    requestAnimationFrame(function () {
      overlay.classList.add("is-visible");
      drawer.classList.add("is-open");
    });
    fetchCart().then(render).catch(function () {});
  }

  function closeDrawer() {
    if (!drawer) return;
    isOpen = false;
    overlay.classList.remove("is-visible");
    drawer.classList.remove("is-open");
    document.documentElement.classList.remove("cart-drawer-locked");
    setTimeout(function () {
      if (!isOpen) { overlay.hidden = true; drawer.hidden = true; }
    }, 320);
  }

  document.addEventListener("DOMContentLoaded", function () {
    var trigger = document.getElementById("cartIconBtn");
    if (trigger) {
      trigger.addEventListener("click", function (e) {
        e.preventDefault();
        openDrawer();
      });
    }
    fetchCart().then(function (cart) { updateBadges(cart.item_count); }).catch(function () {});
  });

  window.DouceNuitCart = { open: openDrawer, refresh: function () { fetchCart().then(function (cart) { updateBadges(cart.item_count); if (isOpen) render(cart); }); } };
})();
